export class Urlparam {
  constructor() {
    this.param = null;
  }

  // 特定のパラメータを取得する
  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    //return decodeURIComponent(results[2].replace(/\+/g, " "));
    this.param = decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // 不特定多数のパラメータを取得する
  // let params = urlparam.getParams(['param1', 'param2'], 'http://example.com?param1=value1&param2=value2');
  getParams(names, url) {
    let paramsArray = [];
    for (let name of names) {
      let param = this.getParam(name, url);
      paramsArray.push(param);
    }
    return paramsArray;
  }

  // パスの取得
  getPath(url) {
    return url.split(/[?#]/)[0];
  }

  // 特定のパラメータを削除する
  removeParams() {
    let url = new URL(window.location.href);
    let url2 = url.pathname.replace(/\?.*$/, "");
    history.replaceState("", "", url2);
  }
}
